import * as React from 'react';
import { icons } from '../../style/icons';
import { MarginContainer } from '../../lib/shared';
import {
  ConferenceBlurb,
  BlurbContainer,
  Frame,
  BlurbMic,
  MobileFrame,
} from './HomePageDescription.style';

const HomePageDescription = ({ conferenceBlurb }) => {
  return (
    <BlurbContainer>
      <MarginContainer>
        <ConferenceBlurb>{conferenceBlurb.text}</ConferenceBlurb>
      </MarginContainer>
      <Frame src={icons.FRAME.image}></Frame>
      <BlurbMic src={icons.BLURB_MIC.image}></BlurbMic>
      <MobileFrame src={icons.MOBILE_FRAME.image}></MobileFrame>
    </BlurbContainer>
  );
};

export default HomePageDescription;
